import { observer } from 'mobx-react'
import React from 'react'
import { match } from '../../../../../../utils/pattern-match-util'
import { OCRScopingStatusNameFilterOptions } from '../../../OCRScopeWorkQueryStringBuilder'
import OCRScopeJobScopingInProgress from './OCRScopeJobDetailEmpty/OCRScopeJobScopingInProgress'
import OCRScopeJobErrorOccurred from './OCRScopeJobDetailEmpty/OCRScopeJobErrorOccurred'
import OCRScopeJobUnderReview from './OCRScopeJobDetailEmpty/OCRScopeJobUnderReview'
import OCRScopeJobUnselected from './OCRScopeJobDetailEmpty/OCRScopeJobUnselected'
import OCRScopeJobDetailBodyBasicInformation from './OCRScopeJobDetailBodyBasicInformation'
import OCRScopingJobsViewModel from '../../../OCRScopingJobsViewModel'
import OCRScopeWork from '../../../../../../wunder/OCRScopeWork'
import styles from './OCRScopeJobDetailBody.sass'
import OCRScopeJobDetailBodyLegendInformation from './OCRScopeJobDetailBodyLegendInformation'
import OCRScopingJobMainPanelViewModel from '../OCRScopingJobMainPanelViewModel'
import ContentLoading from '../../../../../../components/ContentLoading'
import ContentError from '../../../../../../components/ContentError'

interface OCRScopeJobDetailsProps {
  vm: OCRScopingJobsViewModel
}
export default observer(function OCRScopeJobDetailBody({
  vm,
}: OCRScopeJobDetailsProps) {
  const ocrScopingJobMainPanelViewModel = vm.ocrScopingJobMainPanelViewModel
  const selectedScopeWork = ocrScopingJobMainPanelViewModel.selectedScopeWork
  const canManageOCRScopingJobs =
    ocrScopingJobMainPanelViewModel.canManageOCRScopingJobs

  return (
    <div className={styles.detailBodyContainer}>
      {selectedScopeWork === OCRScopeWork.none ? (
        <OCRScopeJobUnselected vm={vm.createOCRScopeJobsViewModel} />
      ) : (
        match(selectedScopeWork.statusName, {
          [OCRScopingStatusNameFilterOptions.SCOPING_IN_PROGRESS]: () => (
            <OCRScopeJobScopingInProgress />
          ),
          [OCRScopingStatusNameFilterOptions.ERROR_OCCURRED]: () => (
            <OCRScopeJobErrorOccurred />
          ),
          [OCRScopingStatusNameFilterOptions.REVIEW_REQUIRED]: () =>
            canManageOCRScopingJobs ? (
              <OCRScopeJobDetailBodyMain vm={ocrScopingJobMainPanelViewModel} />
            ) : (
              <OCRScopeJobUnderReview vm={selectedScopeWork} />
            ),
          [OCRScopingStatusNameFilterOptions.REVIEW_SUGGESTED]: () =>
            canManageOCRScopingJobs ? (
              <OCRScopeJobDetailBodyMain vm={ocrScopingJobMainPanelViewModel} />
            ) : (
              <OCRScopeJobUnderReview vm={selectedScopeWork} />
            ),
          [OCRScopingStatusNameFilterOptions.READY_TO_SUBMIT]: () => (
            <OCRScopeJobDetailBodyMain vm={ocrScopingJobMainPanelViewModel} />
          ),
          [OCRScopingStatusNameFilterOptions.COMPLETED]: () => (
            <OCRScopeJobDetailBodyMain vm={ocrScopingJobMainPanelViewModel} />
          ),
        })
      )}
    </div>
  )
})

interface OCRScopeJobDetailBodyMainProps {
  vm: OCRScopingJobMainPanelViewModel
}
export const OCRScopeJobDetailBodyMain = observer(
  function OCRScopeJobDetailBodyMain({ vm }: OCRScopeJobDetailBodyMainProps) {
    return vm.selectJob.match({
      pending: () => <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () => (
        <div className={styles.detailBodyMain}>
          <div className={styles.leftCol}>
            <OCRScopeJobDetailBodyBasicInformation vm={vm} />
          </div>
          <div className={styles.rightCol}>
            <OCRScopeJobDetailBodyLegendInformation vm={vm} />
          </div>
        </div>
      ),
    })
  },
)
